const Home = () => (
  <section className="home">
    <h1 className="home-header">Math Dojo for Math Magicians</h1>
    <p className="home-text">A place to learn Math Jutsu</p>
  </section>
);
export default Home;
